export default __webpack_public_path__ + "static/splink_3-b34da8bc5e7c1ba4b4076751f7bbc0fc.mp4";